import { OpenWorldPersistenceError } from '@/lib/openWorlds/persistence'
import { isOpenWorldAttemptUuid } from '@/lib/openWorlds/attemptPersistence'
import { isOpenWorldJournalRecord } from '@/lib/openWorlds/journalPersistence'
import type { OpenWorldPendingResponse, OpenWorldResponseSlot } from '@/lib/openWorlds/responses'

const fail = (): never => {
  throw new OpenWorldPersistenceError('backend', 'Malformed response alternative.')
}
export function mapPendingOpenWorldResponse(value: unknown): OpenWorldPendingResponse {
  if (
    !isOpenWorldJournalRecord(value) ||
    Object.keys(value).length !== 5 ||
    !isOpenWorldAttemptUuid(value.id) ||
    !isOpenWorldAttemptUuid(value.attemptId) ||
    typeof value.partialText !== 'string' ||
    typeof value.leaseExpiresAt !== 'string' ||
    !Number.isFinite(Date.parse(value.leaseExpiresAt)) ||
    typeof value.hardDeadlineAt !== 'string' ||
    !Number.isFinite(Date.parse(value.hardDeadlineAt))
  )
    fail()
  return structuredClone(value) as unknown as OpenWorldPendingResponse
}

export function mapOpenWorldResponseSlot(value: unknown): OpenWorldResponseSlot {
  if (
    !isOpenWorldJournalRecord(value) ||
    Object.keys(value).length !== 3 ||
    !isOpenWorldAttemptUuid(value.attemptId) ||
    !isOpenWorldAttemptUuid(value.activeVariantId) ||
    !Array.isArray(value.variants) ||
    value.variants.length < 2
  )
    fail()
  const slot = value as unknown as OpenWorldResponseSlot
  for (const variant of slot.variants) {
    if (
      !isOpenWorldJournalRecord(variant) ||
      Object.keys(variant).length !== 4 ||
      !isOpenWorldAttemptUuid(variant.id) ||
      typeof variant.content !== 'string' ||
      !variant.content.trim() ||
      (variant.editedContent !== null &&
        (typeof variant.editedContent !== 'string' || !variant.editedContent.trim())) ||
      typeof variant.createdAt !== 'string' ||
      !Number.isFinite(Date.parse(variant.createdAt))
    )
      fail()
  }
  if (
    slot.variants[0].id !== slot.attemptId ||
    !slot.variants.some((v) => v.id === slot.activeVariantId) ||
    new Set(slot.variants.map((v) => v.id)).size !== slot.variants.length
  )
    fail()
  return structuredClone(slot)
}
